import React from 'react';
import { healthCalculators } from './ConstantsHealthCalculator';
import SharedHelmet from '.././Helmet';

const TITLE = 'Calculatrices sante et fitness gratuites en ligne';
const DESCRIPTION = 'Accedez a des calculatrices sante en francais: IMC, calories, BMR, hydratation, poids ideal, rythme cardiaque et bien-etre. Outils pratiques pour suivre vos objectifs au quotidien.';
const KEYWORDS = 'calculatrice sante, calculatrice IMC, calcul calories, BMR, poids ideal, apport en eau, rythme cardiaque';
const OG_URL = 'https://do-calculate.com/fr/health-calculators/';

function CalculatorsList() {
    return (
        <div className="container ltr-container">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div>
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-info" role="alert">
                    <p>Comparez rapidement vos indicateurs de sante grace a une collection complete de calculateurs fiables et faciles a utiliser.</p>
                </div>
            </div>
            <hr />
            <table>
                <thead>
                    <tr>
                        <th>Calculatrice</th>
                        <th>Description</th>
                    </tr>
                </thead>
                <tbody>
                    {healthCalculators.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}

export default CalculatorsList;
